import { useMutation } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useSignup from "../../common/hooks/pages/useSignup";
import ChangePassword from "../components/ChangePassword";
import { useNavigate, useParams } from "react-router-dom";

function ChangePasswordContainer() {
  const { toast } = usePopup();

  const { token } = useParams();

  const { changePassword } = useSignup();

  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation({
    mutationFn: changePassword,
    onSuccess: (res) => {
      const { message } = res?.data || {};

      toast(message, "success");

      navigate("/login");
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message || "Something went wrong while login!";
      toast(message, "error");
    },
  });

  return (
    <ChangePassword
      onSubmit={(data) => mutate({ payload: data, token })}
      isSubmitting={isLoading}
    />
  );
}

export default ChangePasswordContainer;
